import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTransition, animated } from "react-spring/web.cjs";
import { debounce, noop } from "lodash-es";
import { onEnter, useIcon } from "../../helpers";
import { positions, arrowPositions, types, getTransaction } from "./options";
import { CheckCircle, Warning, Info, Cancel, Close } from "../../icons";
function useTansitionWrapper(props, className, renderAlertCard) {
  const [show, setShow] = useState(true);
  const transitions = useTransition(show, null, getTransaction(props.position));
  let closeTimer = null;
  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }
  const confirmClose = debounce(() => {
    clearCloseTimer();
    props.onClose();
  }, 500);
  function close(e) {
    if (e) {
      e.stopPropagation();
    }
    setShow(false);
    confirmClose();
  }
  function startCloseTimer() {
    if (props.timeout) {
      closeTimer = setTimeout(() => {
        close();
      }, props.timeout);
    }
  }
  function restartCloseTimer() {
    clearCloseTimer();
    startCloseTimer();
  }
  useEffect(() => {
    startCloseTimer();
    return () => {
      clearCloseTimer();
    };
  }, []);
  useEffect(() => {
    restartCloseTimer();
  }, [props.timeout]);
  return transitions.map(_ref => {
    let {
      item: show,
      props,
      key
    } = _ref;
    return show && /*#__PURE__*/React.createElement(animated.div, {
      key: key,
      style: props,
      className: className
    }, renderAlertCard(close));
  });
}
const AlertCard = props => {
  const {
    children,
    closable,
    type,
    size,
    position,
    prefixClassName,
    arrow,
    arrowPosition
  } = props;
  const arrowClass = arrow ? `arrow arrow-${arrowPosition}` : "";
  const className = `${prefixClassName}-card ${type} ${position} ${size} ${props.className} ${arrowClass}`;
  const icon = useIcon(props.icon);
  let innerIcon = null;
  switch (type) {
    case types.INFO:
    case types.DEFAULT:
      innerIcon = /*#__PURE__*/React.createElement(Info, null);
      break;
    case types.WARNING:
      innerIcon = /*#__PURE__*/React.createElement(Warning, null);
      break;
    case types.ERROR:
      innerIcon = /*#__PURE__*/React.createElement(Cancel, null);
      break;
    case types.SUCCESS:
      innerIcon = /*#__PURE__*/React.createElement(CheckCircle, null);
      break;
  }
  function renderAlertCard(close) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.icon ? icon : innerIcon, /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, children), closable && /*#__PURE__*/React.createElement("span", {
      className: "close-alert",
      tabIndex: "0",
      role: "button",
      onClick: close,
      onKeyPress: onEnter(close)
    }, /*#__PURE__*/React.createElement(Close, {
      tabIndex: "-1"
    })), props.timeout && props.closable && /*#__PURE__*/React.createElement("span", {
      className: "timeout-bar",
      style: {
        animationDuration: `${props.timeout}ms`
      }
    }));
  }
  return props.hasTransition ?
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useTansitionWrapper({
    position,
    onClose: props.onClose,
    timeout: props.timeout
  }, className, renderAlertCard) : /*#__PURE__*/React.createElement("div", {
    className: className
  }, renderAlertCard(props.onClose));
};
AlertCard.defaultProps = {
  prefixClassName: "tui-alert",
  timeout: 5000,
  closable: true,
  type: "",
  size: "md",
  position: "",
  onClose: noop,
  children: null,
  hasTransition: false,
  className: "",
  icon: undefined,
  arrow: false,
  arrowPosition: "top-right"
};
AlertCard.propTypes = {
  prefixClassName: PropTypes.string,
  timeout: PropTypes.number,
  onClose: PropTypes.func,
  closable: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(types)),
  size: PropTypes.string,
  position: PropTypes.oneOf(Object.values(positions)),
  children: PropTypes.any,
  hasTransition: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.func,
  arrow: PropTypes.bool,
  arrowPosition: PropTypes.oneOf(Object.values(arrowPositions))
};
export default AlertCard;
//# sourceMappingURL=AlertCard.js.map